export const ALERT_MUTATION = {
  SHOW_ALERT_YN_MUTATION: "SHOW_ALERT_YN_MUTATION",
  HIDE_ALERT_YN_MUTATION: "HIDE_ALERT_YN_MUTATION",

  SHOW_ALERT_MUTATION: "SHOW_ALERT_MUTATION",
  HIDE_ALERT_MUTATION: "HIDE_ALERT_MUTATION",
};
